import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import FormData from "form-data";
import App from "../../App";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import { connect } from "react-redux";
import {
  AddLoadingLoader,
  RemoveLoadingLoader,
} from "../redux/Actions/UserActions";

let isMounted = false;
// admin document upload component
const AdminUpload = (props) => {
  const [fileType, setFileType] = useState("Select file type");
  const [allLanguages, setallLanguages] = useState([]);
  const [
    dropdownLanguageComponents,
    setDropdownLanguageComponents,
  ] = useState();
  const [languageType, setLanguageType] = useState("Select language");
  const [fileName, setFileName] = useState("Select file");
  const [acceptFileType, setAcceptFileType] = useState("");
  const [fileToUpload, setFileToUpload] = useState("");
  const [loading, setLoading] = useState(false);
  const [hoverTitle, setHoverTitle] = useState(
    "Please select file type and language"
  );

  const toastMessagePopUp = (message) => {
    // toast error message popup
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleSubmit = (event) => {
    // submit  method to upload the file
    props.AddLoadingLoader();
    setLoading(true);

    event.preventDefault();

    const found = allLanguages.find((element) => element.name === languageType);

    // creates a FormData object and adds the parameters and values to it

    const uploadData = new FormData();

    uploadData.append("language_id", found.id);
    uploadData.append("file_type", fileType);
    uploadData.append("file", fileToUpload);

    const id = props.user.museum_id;

    // reset the values
    setFileType("Select file type");
    setLanguageType("Select language");
    setFileName("Select file");
    setHoverTitle("Please select file type and language");
    setAcceptFileType("");

    isMounted = true;

    // do post request to upload the documents
    axios
      .post(App.baseUrl + "api/museum-multimedia/upload/" + id, uploadData)
      .then((response) => {
        if (isMounted) {
          toast.success(response.data.message, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          if (isMounted) {
            setLoading(false);
            setFileToUpload("");
            props.RemoveLoadingLoader();
          }
        }
      })
      .catch((error) => {
        // that falls out of the range of 2xx
        if (error.response) {
          toastMessagePopUp(error.response.data.message);
        } else {
          toastMessagePopUp(
            "Something went wrong, please check your file or internet connection"
          );
        }
        if (isMounted) {
          setFileToUpload("");
          setLoading(false);
          props.RemoveLoadingLoader();
        }
      });
    if (isMounted) {
      setFileToUpload("");
    }
  };

  useEffect(() => {
    // cleanup funtion removes loader and stops the state from getting updating
    return () => {
      isMounted = false;
      props.RemoveLoadingLoader();
    };
  }, []);

  useEffect(() => {
    // calls language api to show them in select language dropdown
    callLangaugesApi();
  }, []);

  useEffect(() => {
    // sets the langauges get from callLanguagesApi() to dropdown items
    setLanguagesToComponents();
  }, [allLanguages, props]);

  const callLangaugesApi = () => {
    // api call to get all the languages available for the museum
    let id = props.user.museum_id;
    const jsonObject = {
      filters: [
        {
          name: "museum_id",
          op: "eq",
          val: id,
        },
      ],
    };
    isMounted = true;
    axios
      .get(App.baseUrl + "api/language", {
        params: {
          q: JSON.stringify(jsonObject),
          page: 1,
          results_per_page: 20,
        },
      })
      .then((data) => {
        setallLanguages(data.data.objects);
      })
      .catch((error) => {
        toastMessagePopUp(error.message + ", please refresh page");
      });
  };

  const setLanguagesToComponents = () => {
    // creates dropdown.items from the languages gotten from callLanguagesApi()
    let allLanguageArray = allLanguages.map((singleData) => {
      return (
        <Dropdown.Item
          key={singleData.id}
          disabled={props.loaderLoading}
          onClick={() => handleLanguageInputChange(singleData.id)}
        >
          {singleData.name}
        </Dropdown.Item>
      );
    });
    setDropdownLanguageComponents(allLanguageArray);
  };

  const handleInputChange = (data) => {
    // handle function for pdf and audio selection in first dropdown
    if (data === "pdf") {
      setFileType("PDF");
      setAcceptFileType(".pdf");
      setFileName("Select file");
    } else {
      setFileType("Audio");
      setAcceptFileType(".mp3,.acc");
      setFileName("Select file");
    }
  };

  const handleLanguageInputChange = (data) => {
    // handle function for select language dropdown
    const found = allLanguages.find((element) => element.id === data);
    setLanguageType(found.name);
  };

  const handleFileInputChange = (event) => {
    // handle function for file upload
    if (event.target.files.length === 1) {
      // if single file is upload
      if (event.target.files[0].size < 100000000) {
        // if size is less than 100MB
        if (fileType === "PDF") {
          // if it is a pdf format
          let allowedExtensions = /(\.pdf)$/i;
          // checks for extensions as .pdf
          if (allowedExtensions.exec(event.target.files[0].name)) {
            if (event.target.files.length === 1) {
              setFileName(event.target.files[0].name);
              setFileToUpload(event.target.files[0]);
              setHoverTitle(event.target.files[0].name);
            }
          } else {
            // error handling
            setFileName("Select a Valid File");
            setFileToUpload("");
            setHoverTitle("Select a Valid File");
          }
        } else if (fileType === "Audio") {
          // if it is a audio format
          let allowedExtensions = /(\.mp3|\.acc)$/i;
          // checks for extensions as .mp3 or .acc
          if (allowedExtensions.exec(event.target.files[0].name)) {
            if (event.target.files.length === 1) {
              setFileName(event.target.files[0].name);
              setFileToUpload(event.target.files[0]);
              setHoverTitle("Select a Valid File");
            }
          } else {
            // handles error
            setFileName("Select a Valid File");
            setFileToUpload("");
            setHoverTitle("Select a Valid File");
          }
        }
      } else {
        // if size greater than 100MB
        toastMessagePopUp("File size exceeds 100Mb");
      }
    } else {
      // different file extension type
      setFileName("Select a Valid File");
      setFileToUpload("");
    }
    event.target.value = null;
  };

  return (
    <div id="upload-page-setup">
      <Form onSubmit={handleSubmit}>
        <div className="upload-page-heading">UPLOAD FILES</div>
        <div>
          <div className="upload-page-fileheading">File Type</div>
          <Dropdown className="upload-page-button">
            <Dropdown.Toggle id="dropdown-basic">{fileType}</Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                disabled={props.loaderLoading}
                onClick={handleInputChange.bind(this, "pdf")}
              >
                PDF
              </Dropdown.Item>
              <Dropdown.Item
                disabled={props.loaderLoading}
                onClick={handleInputChange.bind(this, "audio")}
              >
                Audio
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div>
          <div className="upload-page-fileheading">Language</div>
          <Dropdown className="upload-page-button">
            <Dropdown.Toggle id="dropdown-basic">
              {languageType}
            </Dropdown.Toggle>
            <Dropdown.Menu>{dropdownLanguageComponents}</Dropdown.Menu>
          </Dropdown>
        </div>
        <div>
          <div className="upload-page-fileheading">Upload File</div>
          <div id="upload-page-upload">
            <Form.File custom>
              <Form.File.Input
                id="fileupload-input"
                title={hoverTitle}
                onChange={(event) => handleFileInputChange(event)}
                accept={acceptFileType}
                disabled={
                  fileType === "Select file type" ||
                  languageType === "Select language"
                }
              />
              <Form.File.Label
                id={
                  fileType === "Select file type" ||
                  languageType === "Select language"
                    ? "fileupload-input-disabled"
                    : "fileupload-input"
                }
              >
                {fileName}
              </Form.File.Label>
            </Form.File>
          </div>
        </div>
        <Button
          id="qr-dowload-button"
          className="qrcode-download-button"
          type="submit"
          disabled={
            fileToUpload === "" ||
            fileType === "Select file type" ||
            languageType === "Select language"
          }
        >
          Upload
        </Button>
        {loading ? (
          <Spinner animation="border" id="spinner-border-loading-show" />
        ) : null}
      </Form>
      <ToastContainer
        limit={1}
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.userData.userData,
    loaderLoading: state.userData.loaderLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AddLoadingLoader: () => dispatch(AddLoadingLoader()),
    RemoveLoadingLoader: () => dispatch(RemoveLoadingLoader()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminUpload);
